<section [ngClass]="styles.wrapper">

	<section [ngClass]="styles.section">
		<header [ngClass]="styles.title">
			{{video.title}}
		</header>
		<section class="margin-top-10" *ngIf="video.downloadingEnabled && !isMobile && !playbackConfig?.isEmbedFullPlayer">
			<span [ngClass]="styles.sectionHeader">
				{{ 'Media_Videos_DownloadVideo' | translate }}:
			</span>
			<video-download [enableDownloads]="video.downloadingEnabled" [video]="video">
			</video-download>
		</section>
		<section class="margin-top-10">
			<span [ngClass]="styles.sectionHeader">
				{{ 'Description' | translate }}:
			</span>
			<vb-ui-toggle-content-display *ngIf="video.description?.length" [minHeight]="200">
				<div #vbUiToggleItem [ngClass]="[styles.sectionBodyBlock, styles.description]" [innerHTML]="video.description | safeHtml"></div>
			</vb-ui-toggle-content-display>
		</section>
	</section>

	<section [ngClass]="styles.section">
		<header [ngClass]="styles.sectionHeader" class="box-inline">
			{{ 'Media_Videos_TotalViews' | translate }}:
		</header>
		<span [hidden]="!(video.totalViewsSinceUpload > 0)" [ngClass]="styles.sectionBodyInline">
			{{video.totalViewsSinceUpload | number}}
			<span [hidden]="!video.lastViewed" [ngClass]="styles.lastViewedOn">
				[{{ 'Media_Videos_Playback_LastViewedOn' | translate : { '0': video.lastViewed | vbDateTimeMedium } }}]
			</span>
		</span>
		<span [hidden]="!(video.totalViewsSinceUpload === 0)" [ngClass]="styles.sectionBodyInline">
			{{video.totalViewsSinceUpload | number}}
		</span>
	</section>

	<section [ngClass]="styles.section">
		<header [ngClass]="styles.sectionHeader">
			{{ 'Media_Videos_Owner' | translate }}:
		</header>
		<div [ngClass]="styles.sectionBodyBlock">
			<vb-profile-picture [size]="'large'" [profileUrl]="video.owner.profileImageUri"></vb-profile-picture>
			{{video.owner.firstName || ''}} {{video.owner.lastName || ''}}
		</div>
	</section>

	<section [ngClass]="styles.section">
		<header [ngClass]="styles.sectionHeader">
			{{ 'Media_Videos_UploadDate' | translate }}:
		</header>
		<div [ngClass]="styles.sectionBodyBlock">
			{{ video.whenUploaded | vbDateTimeMedium }}
		</div>
	</section>

	<section [ngClass]="styles.section" *ngIf="!video.isLive">
		<header [ngClass]="styles.sectionHeader">
			{{ 'InThisVideo' | translate }}:
		</header>
		<in-this-video></in-this-video>
	</section>

	<section [ngClass]="styles.section" [hidden]="!(mediaFeatures?.enableCategories
			&& video.categories.length
			&& !playbackConfig?.isEmbedFullPlayer)">
		<header [ngClass]="styles.sectionHeader">
			{{ 'Media_VideoCategories' | translate }}:
		</header>
		<video-categories [ngClass]="styles.sectionBodyBlock" [categories]="video.categories"></video-categories>
	</section>

	<section [ngClass]="styles.section" [hidden]="!video.tags.length">
		<header [ngClass]="styles.sectionHeader">
			{{ 'Tags' | translate }}:
		</header>
		<video-tags [ngClass]="styles.sectionBodyBlock" [tags]="video.tags" [noLinks]="isEmbed">
		</video-tags>
	</section>

	<section [ngClass]="styles.section" *ngIf="filteredCustomFields.length">
		<video-custom-fields [ngClass]="styles.sectionBodyBlock" [customFields]="filteredCustomFields">
		</video-custom-fields>
	</section>

	<section *ngIf="isUserAuthenticated && mediaFeatures?.enableRatings && video.ratingsEnabled" [ngClass]="styles.section">
		<section>
			<header class="box-inline" [ngClass]="styles.sectionHeader">
				{{ 'Media_Videos_Rating' | translate }}:
			</header>
			<span [hidden]="!video.ratingCount">
				<span [ngClass]="styles.averageRating">
					{{video.averageRating | number: '1.1-1'}}
				</span>
				<span [ngClass]="styles.ratingCountText">
					{{video.ratingCount | number}} {{ 'Media_Videos_TotalRatings' | translate }}
				</span>
			</span>
			<span [hidden]="video.ratingCount" [ngClass]="styles.ratingText">
				{{ 'Media_Videos_NoRatings' | translate }}
			</span>
		</section>
		<section class="margin-top-10">
			<header class="box-inline" [ngClass]="styles.sectionHeader">
				{{ 'Media_Videos_My_Rating' | translate }}:
			</header>
			<video-rating [ngClass]="[styles.sectionBodyInline, styles.myRating]" [rating]="video.videoUserRating" [videoId]="video.id" [userId]="UserContext.getUser().id">
			</video-rating>
		</section>
	</section>

	<section *ngIf="video.supplementalContent.length && !playbackConfig?.isEmbedFullPlayer" [ngClass]="styles.section">
		<header [ngClass]="styles.sectionHeader">
			{{ 'Media_Videos_Settings_Files' | translate }}:
		</header>
		<video-supplemental-content class="padding-top-10" [ngClass]="styles.sectionBodyBlock" [playbackConfig]="playbackConfig" [supplementalContents]="video.supplementalContent">
		</video-supplemental-content>
	</section>

	<section *ngIf="video.accessControl === 'Public' && video.password?.length" [ngClass]="styles.section">
		<span class="vb-icon vb-icon-center vb-icon-password" [ngClass]="styles.passwordIcon"></span>
		{{ 'Media_Videos_PasswordProtected' | translate }}
	</section>

	<ng-container *vbAuthorizationKey="'authenticated'">
		<section *ngIf="!video.legalHold" [ngClass]="styles.section">
			<header class="box-inline" [ngClass]="styles.sectionHeader">
				{{ 'Media_Videos_Playback_ReportLabel' | translate }}:
			</header>
			<button (click)="reportInappropiateVideo()" vbBtnSecondary>
				{{ 'Media_Videos_Playback_Report' | translate }}
			</button>
		</section>
	</ng-container>

	<section [ngClass]="styles.section">
		<header [ngClass]="styles.sectionHeader">
			{{ 'Media_Videos_Uploader' | translate }}:
		</header>
		<div [ngClass]="styles.sectionBodyBlock">
			<vb-profile-picture [size]="'large'" [profileUrl]="video.uploader.profileImageUri"></vb-profile-picture>
			{{ video.uploader.firstName || '' }} {{ video.uploader.lastName || '' }}
		</div>
	</section>

</section>
